import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  numbers: {
    id: 'Numeri',
    defaultMessage: 'Numeri',
  },
  bgColor: {
    id: 'Colore di sfondo',
    defaultMessage: 'Colore di sfondo',
  },
  addSectionButton: {
    id: 'Aggiungi una card',
    defaultMessage: 'Aggiungi una card',
  },
  labelButtonNumber: {
    id: 'Label del bottone',
    defaultMessage: 'Label del bottone',
  }
});

const NumbersSchema = (props) => {
  const intl = useIntl();

  return {
    title: intl.formatMessage(messages.numbers),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['bg', 'numbers'],
      },
    ],
    properties: {
      bg: {
        widget: 'select',
        title: intl.formatMessage(messages.bgColor),
        default: 'none',
        choices: [
          ['none', 'Nessuno'],
          ['primary', 'Primario'],
        ],
      },
      numbers: {
        widget: 'object_list',
        schema: {
          title: 'Card',
          addMessage: intl.formatMessage(messages.addSectionButton),
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: [
                'href',
                'href_title'
              ],
            },
          ],
          properties: {
            href: {
              title: 'Link',
              widget: 'object_browser',
              allowExternals: true,
              mode: 'link',
            },
            href_title: {
              title: intl.formatMessage(messages.labelButtonNumber),
            },
          },
          required: [],
        },
      },
    },
    required: [],
  };
};

export default NumbersSchema;
